// Path: src/utils/date.js

export function formatDate(date, format) {
  if (!date) return '';
  
  // 确保date是Date对象
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    console.warn('formatDate函数收到了非有效Date对象:', date);
    try {
      date = new Date(date);
      if (isNaN(date.getTime())) {
        console.error('无法将输入转换为有效的Date对象');
        return '';
      }
    } catch (error) {
      console.error('在formatDate函数中处理日期时出错:', error);
      return '';
    }
  }
  
  const pad = (n) => (n < 10 ? `0${n}` : n);
  const formats = {
    YYYY: date.getFullYear(),
    MM: pad(date.getMonth() + 1),
    DD: pad(date.getDate()),
    HH: pad(date.getHours()),
    mm: pad(date.getMinutes()),
    ss: pad(date.getSeconds()),
  };
  return format.replace(/YYYY|MM|DD|HH|mm|ss/g, (match) => formats[match]);
}

export function getCurDate() {
  const date = new Date();
  return formatDate(date, 'YYYY-MM-DD');
}

export function getCurDateTime() {
  const date = new Date();
  return formatDate(date, 'YYYY-MM-DD HH:mm:ss');
}

